export function displayPhone(number: string) {
  return '0' + number.slice(3) 
}